export default __webpack_public_path__ + "static/media/34I-18681_-14541_0.1e852904.jpg";